<template>
<div id="app" v-loading.fullscreen.lock="!$teras.app.ready" :class="'device-'+$teras.app.device">
   
   <sidebar v-on:toggle="$teras.event.emit('sidebarToggle')" >
      <div slot="sidebar" style="color:#fff;width:100%;line-height:2.4rem;font-size:1.6rem;text-align:center;">Roma, 12-16 giugno 2018</div>
   </sidebar>

   <div class="header-top" >
      <site-header></site-header>
      <site-navbar class="yo-hidden-phone" ></site-navbar>
      <div class="row yo-hidden yo-show-phone" style="    background: #5288C6;" >

         <div class="col s12"><router-link to="/home" style="color:#fff;padding:16px;display:block;">HOME</router-link></div>
         <div class="col s12"><router-link to="/loadpage/progetto/progetto" style="color:#fff;padding:0 16px 16px 16px;display:block;">IL PROGETTO</router-link></div>
         <div class="col s12"><router-link to="/loadpage/progetto/scheda" style="color:#fff;padding:0 16px 16px 16px;display:block;">SCHEDA DATI</router-link></div>

      </div>
   </div>

   <div class="app-main row" style="background:">
      <div id="main" class="col s12" >
         <router-view name="main"></router-view>
      </div><!-- end main -->
   </div><!-- end container -->
   
   
   
   <div class="footer-bottom yo-text-normal">
      <site-footer v-if="!(['savethedate'].indexOf($route.name) > -1)"></site-footer>
   </div>   
   
  <!--
    Il nostro sito web utilizza i cookie per assicurarti la miglior esperienza di navigazione. Se desideri maggiori informazioni sui cookie e su come controllarne l'abilitazione con le impostazioni del browser consulta la nostra Cookie Policy
  -->
  
</div> <!-- end app -->
</template>

<script>
import sidebar from './components/Sidebar'
import siteHeader from './components/Site-header.vue'
import siteNavbar from './components/Site-navbar.vue'
import siteFooter from './components/Site-footer.vue'
export default {
   name: 'app',
   components: {
      sidebar,
      siteHeader,
      siteNavbar,
      siteFooter
   }
}
</script>

<style>
#app {
}
</style>
